<template>
  <v-app id="inspire">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <!--Vertical y horizontal-->
          <v-flex xs12 sm8 md3 lg3>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>Añadir nuevo ítem</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-btn block to="/new/sensor" color="secondary">
                  <v-icon left>mdi-shield-plus</v-icon>
                  Sensor
                </v-btn>
                <v-btn block to="/new/group" color="secondary">
                  <v-icon left>create_new_folder</v-icon>
                  Grupo
                </v-btn>
                <v-btn block to="/new/building" color="secondary">
                  <v-icon left>location_city</v-icon>
                  Edificio
                </v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: "New"
  };
</script>